export const modals = {
  copy: 'Copy configuration template',
  copySuccess: 'Configuration template copied successfully',
  delete: 'Delete configuration template',
  deleteConfirm: 'Are you sure you want to delete the configuration template?',
  deleteSuccess: 'Configuration deleted',
  publishCollisionTitle:
    'A published configuration template with the same criteria already exists',
  publishCollisionDescription:
    'Publishing this configuration template will archive the template listed below.',
  publishCollisionFlowName: 'Configuration template name',
  publishCollisionAuthor: 'Author',
  publishCollisionCreatedAt: 'Created at',
} as const
